import React, { useState } from "react";

import "./DatePickerStyled.styles.scss";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { useDateFormatSelect } from "store";
import dayjs from "dayjs";
import { Box, Button } from "@mui/material";
import toIsoMidday from "utils/to-iso-midday";
import { PopperPlacementType } from "@mui/base";

interface DatePickerStyledProps {
  initialValue?: string;
  onCancelClick: () => void;
  onSave: (date: string) => Promise<void> | void;
  anchorEl: HTMLElement;
  placement?: PopperPlacementType;
  offset?: number[];
}

export const DatePickerStyled: React.FC<DatePickerStyledProps> = ({
  initialValue,
  onCancelClick,
  onSave,
  anchorEl,
  placement = "bottom-start",
  offset
}) => {
  const dateFormat = useDateFormatSelect();

  const [date, setDate] = useState<string>(initialValue ? initialValue : new Date().toISOString());

  return (
    <DesktopDatePicker
      format={dateFormat}
      closeOnSelect={false}
      views={["year", "month", "day"]}
      slotProps={{
        inputAdornment: { position: "start" },
        popper: {
          anchorEl: anchorEl,
          placement,
          modifiers: [
            {
              name: "offset",
              options: {
                offset
              }
            }
          ],
          sx: {
            ".MuiPickersCalendarHeader-labelContainer": {
              fontSize: "0.9rem"
            }
          }
        }
      }}
      value={date ? dayjs(date) : undefined}
      open={!!anchorEl}
      onClose={onCancelClick}
      slots={{
        actionBar: (props) => (
          <Box
            {...props}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: 2,
              gap: "20px"
            }}
          >
            <Button variant="outlined" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button variant="contained" onClick={() => onSave(date)}>
              Save
            </Button>
          </Box>
        ),
        textField: () => null
      }}
      onChange={(date) => {
        if (date && date.isValid()) {
          setDate(toIsoMidday(date?.toISOString()));
        }
      }}
    />
  );
};
